module.exports = {
    unsubEdm: {
        unsubSuccessHeading:
            'You have successfully unsubscribed from all Woolworths Supermarkets Online emails',
        instructions:
            "You'll no longer receive marketing emails from Woolworths Online. Please allow up to 5 business days to take effect",
        unsubNotes:
            '<b>Please note:</b> You’ll continue to receive communications containing factual information about your orders and account. You may also continue to receive Woolworths Rewards marketing emails if you subscribed for them.',
        loginLinkText:
            "If you'd like to receive these emails again, visit <a href=\"/shop/myaccount/preferences\">My Preferences</a> in your online account and resubscribe.",
        alreadyUnsubedHeading:
            'You are already unsubscribed from Woolworths Online marketing emails.',
        alreadyUnsubedSubHeading:
            'If you would like to subscribe to receive Woolworths Online marketing emails to hear about free delivery offers, exclusive discounts, inspiring recipes and special offers, please <a href="/shop/myaccount/preferences">click here</a>.',
        confirmationInstruction:
            "If you proceed, you'll no longer receive emails about product specials, recipes and food inspiration, or discounts and offers for shopping online.",
        unsubYesMessage:
            "Yes, i'd like to unsubscribe from marketing emails",
        unsubNoMessage:
            "No, i'd like to stay subscribed to marketing emails",
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/unsub-edm.js